import React, { useEffect, useState } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import ModelScenariosTab from './ModelScenariosTab';
import SavedScenariosTab from './SavedScenariosTab';
import { fetchSavedSenarios } from '../manage-users/usersSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

const ModelScenariosViews = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.users.user);

  const location = useLocation();
  const history = useHistory();

  const query = new URLSearchParams(location.search);
  const initialKey = query.get('tab') || 'model';
  const [key, setKey] = useState(initialKey);
  const handleSelect = (k) => {
    setKey(k);
    history.replace({
      search: `?tab=${k}`,
    });
  };

  useEffect(() => {
    dispatch(fetchSavedSenarios({ orgId: userInfo.usrOrgId }));
  }, [userInfo.usrOrgId, dispatch]);

  return (
    <Container fluid className="p-0">
      <Tabs activeKey={key} onSelect={handleSelect} className="mb-0">
        <Tab eventKey="model" title="Model Scenarios">
          <ModelScenariosTab />
        </Tab>
        <Tab eventKey="saved" title="Saved Scenarios">
          <SavedScenariosTab />
        </Tab>
      </Tabs>
    </Container>
  );
};

export default ModelScenariosViews;
